import { useEffect, useState } from "react"
import AppContext from './AppContext'
import { data, credit } from '../bootstrap/config'
import { timeAgo, post_at, break_line } from '../bootstrap/helpers'

const AppProvider = ({children}) => {

      const [user, setUser] = useState([])
      const [modal, setModal] = useState(false)
      const [imgObj, setImgObj] = useState({})

      async function getUser(username){

            //const v1_url = `https://xatme.com/api/me/${username}`
            const v2_url = `https://xatme.com/api/v2/all/${username}`

            try{
                  const response = await fetch(v2_url)
                  const result = await response.json()
                  setUser(result)
            }
            catch(err){
                  console.log(err)
            }
      }

      useEffect(() => {
            getUser('jason')
      }, [])

      return <AppContext.Provider value={{user, modal, imgObj, data, credit, setModal, setImgObj, timeAgo, post_at, break_line}}>{children}</AppContext.Provider>
}

export default AppProvider